import { Glue42Core } from "@glue42/core";

import {Glue42Office} from "../../../glue4office";
import {T42ValueEmail, T42ValueTask, TaskPriority} from "../types";
import {CreateItemMethodName} from "./methodNames";
import {validateRecipients} from "./validations";

export const attachmentsErrorMessage = `Invalid type of "attachments" element, expected array of strings for ` +
    `existing attachments or array of "{data: string, fileName: string}" for dynamically created attachments`;

export const isOutlookEnabled = (agm: Glue42Core.AGM.API) => agm.methods({name: CreateItemMethodName}).length > 0;

export const getOlDefaultFolders = () => {
    return {
        $SentMail: 5,
        $Inbox: 6,
    };
};

export const concatChunkData = (data: string[]) => {
    let result = "";
    data.forEach((chunk: string) => {
        result += encodeData(chunk);
    });
    return result;
};

export const encodeData = (data: string) => atob(data);

export const decodeData = (data: string) => btoa(data);

export const generateConversationId = () => {
    return {
        systemName: Math.random().toString(36).substr(2, 10),
        nativeId: new Date().getTime().toString(),
    };
};

export const convertToT42Email = (email: Glue42Office.Outlook.EmailParams): T42ValueEmail => {
    const t42ValueEmail: T42ValueEmail = {
        attachments: email.attachments || [],
        body: email.body,
        bodyHtml: email.bodyHtml,
        subject: email.subject,
    };

    const newEmail: Glue42Office.Outlook.EmailParams = validateRecipients(email);
    ["to", "cc", "bcc"].forEach((contactListName: string) => {
        const receiver = newEmail[contactListName];
        if (receiver) {
            const newList: object[] = [];

            receiver.forEach((contactEmail: string) => {
                newList.push({emails: [contactEmail]});
            });
            t42ValueEmail[contactListName] = newList;
        }

        if (newEmail.sender) {
            t42ValueEmail.sender = {emails: [newEmail.sender]};
        }
    });
    return t42ValueEmail;
};

export const convertToT42Task = (task: Glue42Office.Outlook.TaskParams): T42ValueTask => {
    return {
        attachments: task.attachments || [],
        body: task.body,
        dueDate: task.dueDate,
        importance: getTaskImportance(task.priority),
        reminderTime: task.reminderTime,
        startDate: task.startDate,
        subject: task.subject,
    };
};

const getTaskImportance = (priority: "low" | "normal" | "high") => {
    return typeof TaskPriority[priority] === "number" ? TaskPriority[priority] : TaskPriority.normal;
};

export const getTaskPriority = (importance: number) => {
    if (TaskPriority.low === importance) {
        return "low";
    } else if (TaskPriority.high === importance) {
        return "high";
    }

    return "normal";
};
